const baseUrl = "https://smartkassa.kz/"
// const baseUrl = "http://185.31.160.246:5000/"
function url(path) {
  return baseUrl + path
}

export const testApi = url("api/printBarcode/v1")

export const analyticsApi = url("api/analytics/v1")
export const productAnalyticsApi = url("api/productAnalytics/v1?")

export const shardedAnalyticsApi = url("api/analytics/v1/sharded")
export const productShardedAnalyticsApi = url("api/productAnalytics/v1/sharded")
export const loginApi = url("api/auth/v1/login")
// export const loginApi = "http://10.10.0.15:8088/auth/login"
export const registerApi = url("api/registration/v1")
export const employeeApi = url("api/employee/v1")
export const purchaseApi = url("api/purchase/v1")
export const cashboxApi = url("api/cashbox/v1")
export const roleApi = url("api/role/v1")
export const saleApi = url("api/sale/v1")
export const discountApi = url("api/discount/v1")
export const addItemsApi = url("api/discount/v1/items")
export const stockApi = url("api/stock/v1")
export const storeApi = url("api/store/v1")
export const reportApi = url("api/report/v1/supply")
export const reportInventoryApi = url("api/report/v1/inventory")
export const inventoryApi = url("api/inventory/v1")
export const inventoryFixApi = url("api/inventory/v1/fix")
export const salesReportApi = url("api/sale/v1/period")
export const toRecoverApi = url("api/restore/v1")
export const onRecoverApi = url("api/restore/v1")
export const toFiscalApi = url("api/cashbox/v1/fiscal")
export const taxOfficeApi = url("api/taxInfo/v1")
export const getInfoApi = url("api/xinInfo/v1")
export const getEmplInfoApi = url("api/iinInfo/v1")
export const getItemsWithText = url("app/product/v1/query?")
export const getNumberApi = url("api/restore/v1/number")
export const phoneRecoverApi = url("api/restore/v1/phone")
export const getOrganization = url("api/owner/v1")
export const measuresApi = url("app/measures/v1")
export const addMeasureApi = url("api/inventory/v1/measure")
export const falseFirstEntry = url("api/owner/v1")
export const getAlcoApi = url("ukm/v1/check")
export const storeListApi = url("api/categoryList/v1")
export const productApi = url("api/productInfo/v1")
export const uploadImageApi = url("api/images/v1")
export const getImagesApi = url("api/static/images/")
export const putProductApi = url("app/product/v1")
export const getTariffsGroupsApi = url("cab/tariffsgroups")
export const getTariffsGroupApi = url("cab/tariffs/")
export const getTariffApi = url("cab/tariff/")
export const postTariffPaymentApi = url("cab/tariff/payment")
export const addToCategoryApi = url("app/category/v1")
export const getProductApi = url("api/category/v1/products")
export const storageSearchApi = url("api/category/v1")
export const storageSearchSubmitApi = url("api/category/v1/search")
export const storageAllFilterApi = url("api/property/v1")
export const getCheck = url("app/check/v1/")
export const editProfileApi = url("api/owner/v1")
export const sendFnoFormApi = url("api/fno/read")
export const addProductApi = url("app/product/v1/create")
